import React from 'react'
import PageBanner from '#/components/PageBanner'
import { host } from '#/configs'
import BreadCrumbs from '../AboutCompany/components/BreadCrumbs/BreadCrumbs'
import Layout from './components/Layout'
import NewsList from './components/NewsList'
import styles from './styles.module.scss'
import { AllNewsProps } from './types'

export const NewsHeader = () => (
  <header className={styles['th-news-header']}>
    <BreadCrumbs additional='Room' homeName='Home' pageName='News' />
  </header>
)

const News: React.FC<AllNewsProps> = (
  { allNews: { edges: articles }, preview, intro }
) => {
  const meta = {
    title: 'TopHap featured in publications | TopHap News',
    openGraph: {
      opengraphTitle:
        'TopHap featured in publications | TopHap News',
      opengraphDescription:
        'See what real estate thought leaders are saying about our company and products.'
    },
    image: `${host}/images/blog/tophap-blog.jpg`,
    site_name: 'TopHap featured in publications | TopHap News'
  }

  return (
    <div className={styles['th-news-page']}>
      <Layout meta={meta} preview={preview}>
        <PageBanner text='TopHap in the News' />
        <div className='bg-gray-100'>
          <div className={styles['th-news-layout']}>
            <NewsHeader />
            {articles.length > 0 && <NewsList articles={articles} intro={intro} />}
          </div>
        </div>
      </Layout>
    </div>
  )
}

export default News
